import { useState, useEffect, useContext } from "react";
import axios from "axios";
import AddPermissions from "./AddPermissions";
import EditPermission from "./EditPermission";
import { toast } from "react-toastify";
import { AuthContext } from "../../../Context/AuthContext";
import TableComponent from "../../../utils/TableComponent";
import { Authorization } from "../../../Context/Authorization";

const ManagePermission = () => {
  const [permission, setPermission] = useState([]);
  const [showAddPopup, setShowAddPopup] = useState(false);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [currentState, setCurrentState] = useState(null);
  const { permissions } = useContext(AuthContext);
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const Confiq = Authorization();
        const response = await axios.get(`${Api}/api/users/permissions`, Confiq);
        setPermission(response.data);
      } catch (err) {
        console.error("Error fetching data", err);
      }
    };
    fetchPermissions();
  }, []);

  const handleShowAddPopup = () => { setShowAddPopup(true); };
  const handleCloseAddPopup = () => { setShowAddPopup(false); };

  const handleShowEditPopup = (perm) => {
    setCurrentState(perm);
    setShowEditPopup(true);
  };

  const handleCloseEditPopup = () => {
    setShowEditPopup(false);
    setCurrentState(null);
  };

  const handleDeletePermission = async (id) => {
    if (!window.confirm("Are you sure you want to delete this Permission?")) return;
    try {
      const Confiq = Authorization();
      await axios.delete(`${Api}/api/users/permissions/${id}`, Confiq);
      setPermission(permission.filter((perm) => perm._id !== id));
      toast.success("Deleted Successfully");
    } catch (err) {
      console.error("Error deleting permission", err);
    }
  };

  const handleAddPermission = (newPermission) => { setPermission([...permission, newPermission]); };

  const columns = [
    { headerName: "SI.No", field: "index", valueGetter: (params) => params.node.rowIndex + 1 },
    { headerName: "Permission Name", field: "permissionName" },
    { headerName: "Description", field: "description" },
    {
      headerName: "Action", field: "action",
      cellRenderer: (params) => (
        <div>
          {permissions.includes("EditPermissions") && (
            <i className="mdi mdi-pen" style={{ fontSize: "1.5rem", cursor: "pointer" }}
              onClick={() => handleShowEditPopup(params.data._id)} />
          )}
          {permissions.includes("DeletePermission") && (
            <i className="mdi mdi-delete" style={{ fontSize: "1.5rem", cursor: "pointer" }}
              onClick={() => handleDeletePermission(params.data._id)} />
          )}
        </div>
      ),
    },
  ];

  return (
    <div>
      {/* ── Page Header ── */}
      <div style={{ marginBottom: 20 }}>
        <h4 style={{ margin: 0, fontWeight: 700, color: "#1A202C", fontSize: 18 }}>Permissions</h4>
        <div style={{ fontSize: 12, color: "#718096", marginTop: 3 }}>
          <span style={{ color: "#A0AEC0" }}>User</span>
          <span style={{ margin: "0 6px", color: "#CBD5E0" }}>›</span>
          <span style={{ color: "#2E7D32", fontWeight: 600 }}>Manage Permissions</span>
        </div>
      </div>

      {/* ── Table Card ── */}
      <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", overflow: "hidden" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
          <span style={{ width: 30, height: 30, background: "rgba(255,255,255,0.15)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 15 }}>
            <i className="mdi mdi-shield-key" />
          </span>
          <span style={{ fontSize: 13, fontWeight: 700, color: "#fff", flex: 1 }}>Permission Records</span>
          {permissions.includes("AddPermissions") && (
            <button type="button" onClick={handleShowAddPopup}
              style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "6px 14px", background: "rgba(255,255,255,0.15)", color: "#fff", border: "1px solid rgba(255,255,255,0.3)", borderRadius: 7, fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
              <i className="mdi mdi-plus" /> Create New
            </button>
          )}
        </div>
        <div style={{ padding: 16 }}>
          <TableComponent data={permission} columns={columns} />
        </div>
      </div>

      {showAddPopup && (
        <AddPermissions onClose={handleCloseAddPopup} onAddPermission={handleAddPermission} />
      )}
      {showEditPopup && currentState && (
        <EditPermission permission={currentState} onClose={handleCloseEditPopup} />
      )}
    </div>
  );
};

export default ManagePermission;
